import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconCaretUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCaretUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b98231dc345e06f0466db748b7b17ac23b9f3908', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '870ae2eab3b32e53c1854bc5f0309d47c59b3e90', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7e1f8ee9eacdb3cf66c6c2e252eec09e4395bb47', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.79 8.21-5.28 5.28a.3.3 0 0 0 .21.51h10.56a.3.3 0 0 0 .21-.51l-5.28-5.28a.29.29 0 0 0-.42 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-caret-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-caret-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-caret-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCaretUp$1);
            }
            break;
    } });
}

const CosmosIconCaretUp = CosmosIconCaretUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCaretUp, defineCustomElement };
